import { isOneOf } from "../../helper_functions";
export const methods_sample_size_standard_acceptedValues = [
    '10000', '17000', '17.000', '10.000', "", null, "post-COVID", "post covid", "post-Covid"
];
export function isSampleSizeStandard(elem) {
    return isOneOf(elem, methods_sample_size_standard_acceptedValues);
}
